define([
    'santa-components',
    'prop-types',
    'lodash',
    'componentsCore',
    'datePicker/subComponents/day'
], function (santaComponents, PropTypes, _, componentsCore, day) {
    'use strict';

    /**
     * @class components.Month
     * @extends {core.skinBasedComp}
     */
    return {
        displayName: 'Month',
        propTypes: _.assign({
            id: PropTypes.string.isRequired,
            styleId: PropTypes.string.isRequired,
            dateUtils: PropTypes.object.isRequired,
            calendarDate: PropTypes.object.isRequired,
            today: PropTypes.object.isRequired,
            closeCalendar: PropTypes.func.isRequired,
            onDateChange: PropTypes.func.isRequired,
            isMobileView: santaComponents.santaTypesDefinitions.isMobileView.isRequired,
            isMobileDevice: santaComponents.santaTypesDefinitions.Device.isMobileDevice.isRequired,
            allowPastDates: PropTypes.bool,
            allowFutureDates: PropTypes.bool,
            disabledDates: PropTypes.arrayOf(PropTypes.string),
            disabledDaysOfWeek: PropTypes.arrayOf(PropTypes.number),
            minDate: PropTypes.string,
            maxDate: PropTypes.string,
            selectedDate: PropTypes.object
        }, santaComponents.utils.santaTypesUtils.getSantaTypesByDefinition(day)),
        mixins: [componentsCore.mixins.skinBasedComp, componentsCore.mixins.createChildComponentMixin],
        getInitialState() {
            return {
                $mobile: this.props.isMobileDevice || this.props.isMobileView ? 'mobile' : 'notMobile'
            };
        },
        isWeekInMonth(startOfWeek) {
            const dateUtils = this.props.dateUtils;
            const calendarDate = this.props.calendarDate;
            const endOfWeek = dateUtils.helpers.addDays(startOfWeek, 6);

            return dateUtils.helpers.isSameMonth(startOfWeek, calendarDate) || dateUtils.helpers.isSameMonth(endOfWeek, calendarDate);
        },
        generateDays(startOfWeek) {
            const dateUtils = this.props.dateUtils;
            const isoWeek = dateUtils.helpers.getISOWeek(startOfWeek);

            return _(dateUtils.constants.NUMBER_OF_DAYS_IN_WEEK)
                .range()
                .map(function (dayOffset) {
                    return this.createChildComponent({}, 'wysiwyg.viewer.components.Day', 'day', {
                        id: `${this.props.id}week${isoWeek}day${dayOffset}`,
                        ref: `${this.props.id}week${isoWeek}day${dayOffset}`,
                        key: `${this.props.id}week${isoWeek}day${dayOffset}`,
                        style: {},
                        dateUtils: this.props.dateUtils,
                        day: dateUtils.helpers.addDays(startOfWeek, dayOffset),
                        today: this.props.today,
                        onDateChange: this.props.onDateChange,
                        closeCalendar: this.props.closeCalendar,
                        selectedDate: this.props.selectedDate,
                        calendarDate: this.props.calendarDate,
                        disabledDates: this.props.disabledDates,
                        disabledDaysOfWeek: this.props.disabledDaysOfWeek,
                        allowPastDates: this.props.allowPastDates,
                        allowFutureDates: this.props.allowFutureDates,
                        minDate: this.props.minDate,
                        maxDate: this.props.maxDate
                    });
                }.bind(this))
                .value();
        },
        generateWeeks() {
            const dateUtils = this.props.dateUtils;
            const startDayOfTheMonth = dateUtils.helpers.getStartDayOfTheMonth(this.props.calendarDate);
            const startOfFirstWeekInMonth = dateUtils.helpers.getStartDayOfTheWeek(startDayOfTheMonth, {weekStartsOn: 1});

            return _(dateUtils.constants.MAX_NUMBER_OF_WEEKS)
                .range()
                .map(weekOffset => this.props.dateUtils.helpers.addWeeks(startOfFirstWeekInMonth, weekOffset))
                .filter(weekDay => this.isWeekInMonth(weekDay))
                .map(startOfWeek =>
                    santaComponents.utils.createReactElement(
                        'div',
                        {className: this.classSet({week: true})},
                        this.generateDays(startOfWeek)
                    ))
                .value();
        },
        getSkinProperties() {
            return {
                '': {
                    children: this.generateWeeks()
                }
            };
        }
    };
});
